import type { CSSProperties, ReactNode } from 'react';

/**
 * Seamless infinite marquee. Renders the items twice inside a `max-content`
 * track that slides -50% on a linear loop (the one context where linear easing
 * is correct, per emil-design-eng). Edges fade via a mask; hover pauses it so
 * the content stays readable. Static when reduced motion is requested.
 */
export function Marquee({
  items,
  durationSec = 40,
  className,
}: {
  items: ReactNode[];
  durationSec?: number;
  className?: string;
}) {
  return (
    <div className={`marquee ${className ?? ''}`}>
      <div className="marquee-track" style={{ '--marquee-dur': `${durationSec}s` } as CSSProperties}>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <div key={i} className="flex items-center">
                {item}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
